var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionRouteAppearance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_2353_9002_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.70817e-09 0.0165 0.0160875 1.68502e-09 15 16)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -787.879,
    y: -787.879,
    width: 1575.76,
    height: 1575.76
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(130, 1, 255, 1) 0deg,rgba(46, 185, 0, 1) 90deg,rgba(255, 222, 2, 1) 180deg,rgba(255, 1, 34, 1) 270deg,rgba(130, 1, 255, 1) 359.5deg,rgba(130, 1, 255, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C11.7614 3 14 5.23858 14 8V16C14 16.5177 14.3933 16.9438 14.8975 16.9951L15 17C15.5523 17 16 16.5523 16 16V8C16 6.89543 16.8954 6 18 6C19.1046 6 20 6.89543 20 8V16C20 18.7614 17.7614 21 15 21L14.7432 20.9932C12.1011 20.8595 10 18.6753 10 16V8C10 7.44772 9.55228 7 9 7C8.44772 7 8 7.44772 8 8V12.8633C7.48984 12.3228 6.77143 12 6 12C5.22857 12 4.51016 12.3228 4 12.8633V8C4 5.23858 6.23858 3 9 3Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.50980395078659058,\"g\":0.0039215688593685627,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.18039216101169586,\"g\":0.72549021244049072,\"b\":0.0,\"a\":1.0},\"position\":0.250},{\"color\":{\"r\":1.0,\"g\":0.87058824300765991,\"b\":0.0078431377187371254,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":1.0,\"g\":0.0039215688593685627,\"b\":0.13333334028720856,\"a\":1.0},\"position\":0.750},{\"color\":{\"r\":0.50980395078659058,\"g\":0.0039215688593685627,\"b\":1.0,\"a\":1.0},\"position\":0.99861109256744385}],\"stopsVar\":[{\"color\":{\"r\":0.50980395078659058,\"g\":0.0039215688593685627,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.18039216101169586,\"g\":0.72549021244049072,\"b\":0.0,\"a\":1.0},\"position\":0.250},{\"color\":{\"r\":1.0,\"g\":0.87058824300765991,\"b\":0.0078431377187371254,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":1.0,\"g\":0.0039215688593685627,\"b\":0.13333334028720856,\"a\":1.0},\"position\":0.750},{\"color\":{\"r\":0.50980395078659058,\"g\":0.0039215688593685627,\"b\":1.0,\"a\":1.0},\"position\":0.99861109256744385}],\"transform\":{\"m00\":-3.4163331292802468e-06,\"m01\":32.175003051757812,\"m02\":-1.0874966382980347,\"m10\":33.0,\"m11\":3.3700459880492417e-06,\"m12\":-0.50000101327896118},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11C16.3431 11 15 9.65688 15 8.00003C15 6.34318 16.3431 5.00003 18 5.00003C19.6569 5.00003 21 6.34318 21 8.00003C21 9.65688 19.6569 11 18 11Z",
    fill: "url(#paint1_linear_2353_9002)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C17.4477 9 17 8.55228 17 8C17 7.44772 17.4477 7 18 7C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9Z",
    fill: "#4A6501"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9359 19.8462L6.69231 14.4615C6.57586 14.1821 6.30278 14 6 14C5.69722 14 5.42414 14.1821 5.30769 14.4615L3.0641 19.8462C3.02179 19.9477 3 20.0566 3 20.1667V20.191C3 20.6378 3.36221 21 3.80902 21C3.93461 21 4.05848 20.9708 4.17082 20.9146L6 20L7.82918 20.9146C7.94152 20.9708 8.06539 21 8.19098 21C8.63779 21 9 20.6378 9 20.191V20.1667C9 20.0566 8.97821 19.9477 8.9359 19.8462Z",
    fill: "url(#paint2_linear_2353_9002)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9359 19.8462L6.69231 14.4615C6.57586 14.1821 6.30278 14 6 14C5.69722 14 5.42414 14.1821 5.30769 14.4615L3.0641 19.8462C3.02179 19.9477 3 20.0566 3 20.1667V20.191C3 20.6378 3.36221 21 3.80902 21C3.93461 21 4.05848 20.9708 4.17082 20.9146L6 20L7.82918 20.9146C7.94152 20.9708 8.06539 21 8.19098 21C8.63779 21 9 20.6378 9 20.191V20.1667C9 20.0566 8.97821 19.9477 8.9359 19.8462Z",
    fill: "#5714CC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_2353_9002_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3C11.7614 3 14 5.23858 14 8V16C14 16.5177 14.3933 16.9438 14.8975 16.9951L15 17C15.5523 17 16 16.5523 16 16V8C16 6.89543 16.8954 6 18 6C19.1046 6 20 6.89543 20 8V16C20 18.7614 17.7614 21 15 21L14.7432 20.9932C12.1011 20.8595 10 18.6753 10 16V8C10 7.44772 9.55228 7 9 7C8.44772 7 8 7.44772 8 8V12.8633C7.48984 12.3228 6.77143 12 6 12C5.22857 12 4.51016 12.3228 4 12.8633V8C4 5.23858 6.23858 3 9 3Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2353_9002",
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 5.00003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CB01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D602"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2353_9002",
    x1: 4,
    y1: 14,
    x2: 9,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionRouteAppearance);
export default __webpack_public_path__ + "static/media/ic_action_route_appearance.fd20c9a2c8e21a65b622f483a198fbb7.svg";
export { ForwardRef as ReactComponent };